// ─────────────────────────────────────────────────────────────
// MOCK DATA — development only
// BACKEND: All of these are replaced by real API responses.
//   See services/ for the corresponding endpoint specs.
// ─────────────────────────────────────────────────────────────

export const MOCK_FACILITIES = [
  { id: 1, name: 'Lincoln Park SNF', addr: '2537 N. Clark St', phone: '312-555-0101', contact: 'Nurse Johnson', est: '9:15 AM', samples: 6, types: ['Blood', 'Urine'], special: 'Use side entrance', priority: true },
  { id: 2, name: 'Logan Square Care', addr: '2452 N. Milwaukee Ave', phone: '312-555-0182', contact: 'Nurse Patel', est: '10:00 AM', samples: 4, types: ['Blood'], special: 'Logan Square — Mon–Fri', priority: false },
  { id: 3, name: 'Wicker Park Rehab', addr: '1818 W. Division St', phone: '312-555-0147', contact: 'Nurse Torres', est: '10:45 AM', samples: 3, types: ['Blood', 'Frozen'], special: '', priority: false },
  { id: 4, name: 'Oak Park Skilled Care', addr: '700 S. Oak Park Ave', phone: '708-555-0133', contact: 'Nurse Kim', est: '11:30 AM', samples: 8, types: ['Blood', 'Urine'], special: '', priority: true },
  { id: 5, name: 'Lakeview Nursing', addr: '3400 N. Lake Shore Dr', phone: '773-555-0162', contact: 'Nurse Davis', est: '1:00 PM', samples: 2, types: ['Blood'], special: '', priority: false },
  { id: 6, name: 'Pilsen Elder Care', addr: '1908 S. Blue Island Ave', phone: '312-555-0199', contact: 'Nurse Reyes', est: '2:15 PM', samples: 5, types: ['Blood', 'Urine', 'Frozen'], special: '', priority: false },
];

export const MOCK_STOP_STATES = { 1: 2, 2: 3, 3: 1, 4: 0, 5: 0, 6: 0 };

export const MOCK_STOP_PHOTOS = {
  1: [{ id: 'p1a', label: 'Arrival photo', timestamp: '8:47 AM' },
  { id: 'p1b', label: 'Specimen tray', timestamp: '9:03 AM' }],
  2: [{ id: 'p2a', label: 'Arrival photo', timestamp: '9:22 AM' },
  { id: 'p2b', label: 'Specimens ready', timestamp: '9:31 AM' },
  { id: 'p2c', label: 'Note: check fridge', timestamp: '9:35 AM' }],
};

export const MOCK_STOP_NOTES = {
  2: 'Samples in front desk cooler — check fridge too',
};

export const MOCK_DRAW_LIST_PHOTOS = { 1: true };

export const MOCK_DRIVER_STOPS = [
  {
    id: 1,
    name: 'Lincoln Park SNF',
    addr: '2537 N. Clark St', 
    estPickup: '9:45 AM', 
    samples: 6, 
    status: 4, 
    photos: [{ id: 'p1a', label: 'Arrival photo' }, { id: 'p1b', label: 'Specimen tray' }], 
    note: '', priority: true, sortOrder: 1
  },
  { id: 2, name: 'Logan Square Care', addr: '2452 N. Milwaukee Ave', estPickup: '10:30 AM', samples: 4, status: 4, photos: [{ id: 'p2a', label: 'Arrival photo' }, { id: 'p2b', label: 'Specimens ready' }], note: 'Samples in front desk cooler — check fridge too', priority: false, sortOrder: 2 },
  { id: 3, name: 'Wicker Park Rehab', addr: '1818 W. Division St', estPickup: '11:15 AM', samples: 3, status: 3, photos: [{ id: 'p3a', label: 'Arrival photo' }, { id: 'p3b', label: 'Specimen tray' }], note: '', priority: false, sortOrder: 3 },
  { id: 4, name: 'Oak Park Skilled Care', addr: '700 S. Oak Park Ave', estPickup: '12:00 PM', samples: 8, status: 3, photos: [{ id: 'p4a', label: 'Arrival photo' }, { id: 'p4b', label: 'Specimens on counter' }], note: 'Patient in room 4 refused — 7 draws total', priority: true, sortOrder: 4 },
  { id: 5, name: 'Lakeview Nursing', addr: '3400 N. Lake Shore Dr', estPickup: '1:30 PM', samples: 2, status: 3, photos: [{ id: 'p5a', label: 'Arrival photo' }, { id: 'p5b', label: 'Specimen bag' }], note: '', priority: false, sortOrder: 5 },
  { id: 6, name: 'Pilsen Elder Care', addr: '1908 S. Blue Island Ave', estPickup: '2:45 PM', samples: 5, status: 2, photos: [], note: '', priority: false, sortOrder: 6 },
  { id: 7, name: 'Bridgeport Care', addr: '3000 S. Halsted St', estPickup: '3:15 PM', samples: 4, status: 1, photos: [], note: '', priority: false, sortOrder: 7 },
  { id: 8, name: 'Hyde Park Nursing', addr: '5400 S. Cornell Ave', estPickup: '4:00 PM', samples: 3, status: 0, photos: [], note: '', priority: false, sortOrder: 8 },
];

export const MOCK_ADMIN_ASSIGNMENTS = [
  { day: 'Mon', phleb: 'Maria P.', facilities: ['Lincoln Park', 'Logan Square', 'Lakeview'] },
  { day: 'Tue', phleb: 'Maria P.', facilities: ['Wicker Park', 'Oak Park', 'Pilsen'] },
  { day: 'Wed', phleb: 'Carlos R.', facilities: ['Lincoln Park', 'Bridgeport', 'Hyde Park'] },
  { day: 'Thu', phleb: 'Maria P.', facilities: ['Logan Square', 'Wicker Park', 'Lakeview'] },
  { day: 'Fri', phleb: 'Carlos R.', facilities: ['Oak Park', 'Pilsen', 'Hyde Park'] },
];

export const MOCK_EXCEPTIONS = [
  { id: 'e1', facility: 'Bridgeport Care', note: 'Patient refused draw — rescheduling needed', time: '8:52 AM', phleb: 'Carlos R.' },
  { id: 'e2', facility: 'Hyde Park Nursing', note: 'Site closed — no staff on floor', time: '7:40 AM', phleb: 'Carlos R.' },
];

export const MOCK_USERS = {
  phleb: { id: 'u1', name: 'Maria Perez', initials: 'MP', role: 'phleb', email: 'm.perez@cimpar.com', phone: '312-555-0201', smsNumber: '312-555-0201' },
  driver: { id: 'u2', name: 'Armando Vasquez', initials: 'AV', role: 'driver', email: 'a.vasquez@cimpar.com', phone: '773-555-0301', smsNumber: '773-555-0301' },
  admin: { id: 'u3', name: 'Jason Lee', initials: 'JL', role: 'admin', email: 'j.lee@cimpar.com', phone: '312-555-0101', smsNumber: '312-555-0101' },
};
